import { Component } from '@angular/core';
import { inject } from '@angular/core';
import { OrderProcessingService } from 'app/server/server.module';
import { OrderlinePanelComponent } from 'app/shared/orderline-panel/orderline-panel.component';
import { takeUntil } from 'rxjs';

@Component({
  selector: 'app-client-queries',
  templateUrl: '../../shared/orderline-panel/orderline-panel.component.html',
  styleUrls: ['../../shared/orderline-panel/orderline-panel.component.scss']
})
export class ClientQueriesComponent extends OrderlinePanelComponent {
  private readonly orderService = inject(OrderProcessingService);

  constructor() {
    super();
    this.title = "Client Queries";
  }

  refreshData(): void {
    if (this.selectedAdmin !== null) {
      this.orderService.getClientQueries(this.selectedAdmin).pipe(takeUntil(this.destroy$)).subscribe(res => this.datasource = res || []);
    }
  }
}
